module.exports = __webpack_public_path__ + "static/media/awardBtn.bd98a7d7.png";